import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './leftarrow.svg'


_pushScopeId("data-v-504babf6")
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "trending-pairs" }
const _hoisted_3 = {
  key: 0,
  class: "flex justify-between p-3"
}
const _hoisted_4 = { class: "title" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "border" }, null, -1)
const _hoisted_6 = { class: "flex flex-wrap gap-3 px-1 lg:p-3" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
_popScopeId()

import { getAddress } from '@ethersproject/address';
import { getUnixTime } from 'date-fns';
import { computed } from 'vue';
import { useQuery } from 'vue-query';

import { useTradeState } from '@/composables/trade/useTradeState';
import useBreakpoints from '@/composables/useBreakpoints';
import QUERY_KEYS from '@/constants/queryKeys';
import { balancerSubgraphService } from '@/services/balancer/subgraph/balancer-subgraph.service';
import useWeb3 from '@/services/web3/useWeb3';

type TrendingPair = {
  symbol: string;
  address: string;
};


export default _defineComponent({
  setup(__props) {

const { setTokenOutAddress, setTokenInAddress } = useTradeState();
const { chainId: userNetworkId, appNetworkConfig } = useWeb3();
const { upToLargeBreakpoint } = useBreakpoints();

const getTrendingTradePairs = async () => {
  return await balancerSubgraphService.tradePairSnapshots.get({
    orderBy: 'totalSwapVolume',
    orderDirection: 'desc',
    where: {
      timestamp_gte: getUnixTime(new Date().setUTCHours(0, 0, 0, 0)),
    },
    first: 6,
  });
};

const { data: tradePairSnapshots } = useQuery(
  QUERY_KEYS.Tokens.TrendingPairs(userNetworkId),
  () => getTrendingTradePairs()
);

function formatToken({ address, symbol }: { address: string; symbol: string }) {
  const formatted = getAddress(address);

  if (formatted === appNetworkConfig.addresses.weth) {
    return {
      address: appNetworkConfig.nativeAsset.address,
      symbol: appNetworkConfig.nativeAsset.symbol,
    };
  }

  return {
    address: formatted,
    symbol,
  };
}

const trendingPairs = computed(() => {
  return (tradePairSnapshots.value || []).map(pairSnapshot => [
    formatToken(pairSnapshot.pair.token0),
    formatToken(pairSnapshot.pair.token1),
  ]);
});

const setTradePair = (pair: TrendingPair[]) => {
  setTokenInAddress(pair[0].address);
  setTokenOutAddress(pair[1].address);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (!_unref(upToLargeBreakpoint))
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("h6", _hoisted_4, _toDisplayString(_ctx.$t('trendingPairs')), 1)
          ]))
        : _createCommentVNode("", true),
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(trendingPairs), (pair, i) => {
          return (_openBlock(), _createElementBlock("button", {
            key: `trendingPair-${i}`,
            class: "pair flex items-center rounded-lg border bg-transparent py-1 px-2 text-sm font-medium shadow-sm transition-colors hover:bg-blue-500 hover:text-white dark:border-gray-800 dark:hover:bg-blue-400 lg:font-normal",
            onClick: ($event: any) => (setTradePair(pair))
          }, [
            _createElementVNode("div", null, _toDisplayString(pair[0].symbol) + " ", 1),
            _hoisted_8,
            _createElementVNode("div", null, " " + _toDisplayString(pair[1].symbol), 1)
          ], 8, _hoisted_7))
        }), 128))
      ])
    ])
  ]))
}
}

})